import {useCallback, useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Dropdown, Layout, Menu} from 'antd';
import {AuthContext} from 'context/Auth.context';
import {CaretDown, List, User, X} from 'phosphor-react';
import UFAR_Logo_white from 'assets/ufar-logo-white.svg';
import ConfirmModal from 'components/ConfirmModal';
import useMediaQuery from 'hooks/useMediaQuery.hook';
import './Header.less';
import {StudentContext} from 'context/Student.context';

const {Header} = Layout;

const AppHeader = ({role}: {role: 'CANDIDATE' | 'STUDENT'}) => {
	const navigate = useNavigate();
	const location = useLocation();

	const {state, dispatch} = useContext(AuthContext);
	const {
		state: {candidateID}
	} = useContext(StudentContext);

	const [choosenPage, setChoosenPage] = useState(location.pathname);
	// const [lang, setLang] = useState('ՀԱՅ');
	const [menuOpen, setMenuOpen] = useState(false);

	const isDesktop = useMediaQuery('(min-width: 768px)');

	const handleLogout = () => {
		ConfirmModal({
			title: 'Դուրս գալ',
			content: 'Ուզու՞մ եք լքել համակարգը',
			onSubmit: () => {
				dispatch({
					type: 'LOGOUT'
				});
			}
		});
	};

	const handleSelectMenuItem = useCallback(
		({key}: {key: string}) => {
			if (key === 'logout') {
				handleLogout();
				return;
			}

			setChoosenPage(key);
			navigate(key);
		},
		[choosenPage]
	);

	useEffect(() => {
		setChoosenPage(location.pathname);
	}, [location.pathname]);

	return (
		<Header>
			<div
				className="logo"
				onClick={() => {
					navigate('/');
				}}>
				<img src={UFAR_Logo_white} alt="UFAR_Logo_white" width="100rem" style={{marginRight: 14}} />
			</div>
			<div className="menu">
				{!!state.isAuthenticated ? (
					<div style={isDesktop ? {display: 'flex'} : {display: 'flex', minWidth: 570}}>
						<Menu
							onOpenChange={() => {
								setMenuOpen(prev => !prev);
							}}
							mode="horizontal"
							theme="dark"
							className="menu"
							style={isDesktop ? {minWidth: 1200} : {}}
							openKeys={menuOpen ? ['rc-menu-more'] : undefined}
							overflowedIndicator={
								!menuOpen ? (
									<List
										onClick={() => setMenuOpen(true)}
										size={28}
										style={{marginTop: 25}}
										weight="fill"
									/>
								) : (
									<X
										onClick={() => setMenuOpen(false)}
										size={28}
										style={{marginTop: 25}}
										weight="fill"
									/>
								)
							}
							onSelect={handleSelectMenuItem}
							defaultSelectedKeys={[choosenPage]}
							selectedKeys={[choosenPage]}>
							<Menu.Item key="/">Գլխավոր</Menu.Item>
							<Menu.Item key="/admission" disabled={role === 'STUDENT' && candidateID === null}>
								Ընդունելություն
							</Menu.Item>
							{role === 'STUDENT' && (
								<>
									<Menu.Item key="/exams">Քննություններ</Menu.Item>
									<Menu.Item key="/timetable">Դասացուցակ</Menu.Item>
									<Menu.Item key="/applications">Դիմումներ</Menu.Item>
									<Menu.Item key="/commands">Հրամաններ</Menu.Item>
									<Menu.Item key="/diplomaWork">Ավարտական աշխատանք</Menu.Item>
								</>
							)}
							{!isDesktop ? (
								<>
									<Menu.Item key="/profile">Իմ հաշիվը</Menu.Item>
									<Menu.Item key="logout">Դուրս գալ</Menu.Item>
								</>
							) : null}
						</Menu>
						{isDesktop ? (
							<div className="right-actions">
								{/* <Dropdown
								trigger={['click']}
								placement="bottom"
								overlay={() => (
									<Menu className="lang-dropdown">
										<Menu.Item key="0">
											<a onClick={() => setLang('ՀԱՅ')}>ՀԱՅ</a>
										</Menu.Item>
										<Menu.Item key="1">
											<a onClick={() => setLang('ENG')}>ENG</a>
										</Menu.Item>
										<Menu.Item key="2">
											<a onClick={() => setLang('FRE')}>FRE</a>
										</Menu.Item>
									</Menu>
								)}>
								<a className="lang-link" onClick={e => e.preventDefault()}>
									{lang}
								</a>
							</Dropdown> */}
								{/* <BellSimple weight="fill" size={24} color="white" /> */}
								<Dropdown
									trigger={['click']}
									overlay={() => (
										<Menu className="profile-dropdown">
											<Menu.Item
												key="0"
												onClick={() => handleSelectMenuItem({key: '/profile'})}>
												<a>Իմ հաշիվը</a>
											</Menu.Item>
											<Menu.Item key="1">
												<a onClick={handleLogout}>Դուրս գալ</a>
											</Menu.Item>
										</Menu>
									)}>
									<a onClick={e => e.preventDefault()} className="profile-link">
										<User
											style={{
												border: '1px solid white',
												borderRadius: 8,
												padding: 4,
												boxSizing: 'content-box'
											}}
											size={16}
											weight="fill"
										/>
										<CaretDown style={{marginLeft: 10}} size={16} weight="fill" />
									</a>
								</Dropdown>
							</div>
						) : null}
					</div>
				) : null}
			</div>
		</Header>
	);
};

export default AppHeader;
